import { createSlice } from "@reduxjs/toolkit"

import { CREDITS_AUTOMATION_SLICE_NAME } from "./creditsAutomation.constants"
import {
  getCreditsAutomationList,
  getStatusOptions,
  updateAccessRequestStatus
} from "./creditsAutomation.thunks"

const initialState = {
  fetching: false,
  results: [],
  count: 0,

  updateStatusFetching: false,

  statusOptionsFetching: false,
  reasonOptions: []
}

const slice = createSlice({
  name: CREDITS_AUTOMATION_SLICE_NAME,
  initialState,
  reducers: {
    // TODO CHA1-3068 (not started - BE ticket): local-only mock mutation, there's no backend
    // endpoint yet for adding a row comment. Replace with a real thunk once that endpoint ships.
    addComment(state, action) {
      const { id, comment } = action.payload
      state.results = state.results.map((item) =>
        item.id === id ? { ...item, action_needed_details: comment } : item
      )
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCreditsAutomationList.pending, (state) => {
        state.fetching = true
      })
      .addCase(getCreditsAutomationList.fulfilled, (state, action) => {
        state.fetching = false
        state.results = action.payload.results
        state.count = action.payload.count
      })
      .addCase(getCreditsAutomationList.rejected, (state) => {
        state.fetching = false
      })

      .addCase(updateAccessRequestStatus.pending, (state) => {
        state.updateStatusFetching = true
      })
      .addCase(updateAccessRequestStatus.fulfilled, (state, action) => {
        state.updateStatusFetching = false
        const { id, ...rest } = action.payload
        state.results = state.results.map((item) => (item.id === id ? { ...item, ...rest } : item))
      })
      .addCase(updateAccessRequestStatus.rejected, (state) => {
        state.updateStatusFetching = false
      })

      .addCase(getStatusOptions.pending, (state) => {
        state.statusOptionsFetching = true
      })
      .addCase(getStatusOptions.fulfilled, (state, action) => {
        state.statusOptionsFetching = false
        state.reasonOptions = action.payload.reason_options
      })
      .addCase(getStatusOptions.rejected, (state) => {
        state.statusOptionsFetching = false
      })
  }
})

export const creditsAutomationActions = slice.actions

export const CreditsAutomationSelectors = {
  getCreditsAutomation: (state) => state[CREDITS_AUTOMATION_SLICE_NAME]
}

export const reducer = slice.reducer
